module.exports = __webpack_public_path__ + "img/5.76cdfc0a.jpg";